import {
  FormControl, InputLabel, Select, MenuItem,
  ListItemIcon, ListItemText, Divider,
} from '@mui/material'
import { CreateNewFolder } from '@mui/icons-material'
import { foldersNewestFirst } from '../../utils/folderSelection'

// The folder dropdown. Creating a folder opens the Create a Folder form
// (FAR-49) rather than editing a name inline: the old inline field had no
// Description and saved on blur, so clicking away created a half-named folder.

const NEW_FOLDER = '__new__'

export default function FolderSelector({ folders, selectedFolderId, onSelect, onCreateFolder }) {
  const ordered = foldersNewestFirst(folders)
  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Folder</InputLabel>
      <Select
        value={selectedFolderId || ''}
        label="Folder"
        onChange={(e) => {
          if (e.target.value === NEW_FOLDER) onCreateFolder?.()
          else onSelect(e.target.value)
        }}
        renderValue={(val) => {
          const folder = folders.find((f) => f.id === val)
          return folder?.name || 'All Plans'
        }}
      >
        {ordered.map((f) => (
          <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
        ))}
        {ordered.length > 0 && <Divider />}
        <MenuItem value={NEW_FOLDER}>
          <ListItemIcon><CreateNewFolder fontSize="small" /></ListItemIcon>
          <ListItemText>New Folder…</ListItemText>
        </MenuItem>
      </Select>
    </FormControl>
  )
}
